import { render, staticRenderFns } from "./v3.vue?vue&type=template&id=5ccfe4f4&scoped=true"
import script from "./v3.vue?vue&type=script&lang=js"
export * from "./v3.vue?vue&type=script&lang=js"
import style0 from "./v3.vue?vue&type=style&index=0&id=5ccfe4f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccfe4f4",
  null
  
)

export default component.exports